// extracted by mini-css-extract-plugin
export default {"input":"Autocomplete_input__1m7kV","suggestion":"Autocomplete_suggestion__aMrH7","active-suggestion":"Autocomplete_active-suggestion__13SZn"};